module.exports = require("core-js-pure/stable/instance/slice");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/slice.js
// module id = 92
// module chunks = 0 7 8 9 10 11